import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import React, { FC, useEffect, useCallback } from 'react'
import { Yakureki } from '@/shared/types/yakurekiCore'
import { Pharmacist } from '@/features/auth/types/pharmacy'

type Props = {
  name: string
  setName: (name: string) => void
  isRecording: boolean
  audioURL?: string | null
  recordButton: JSX.Element
  patientList: Yakureki[]
  pharmacistId: string
  setPharmacistId: (id: string) => void
  pharmacistList: Pharmacist[]
  memo: string
  setMemo: (memo: string) => void
}

export const RecordModalBody: FC<Props> = ({
  name,
  setName,
  recordButton,
  patientList,
  pharmacistId,
  setPharmacistId,
  pharmacistList,
  memo,
  setMemo,
}) => {
  const createLabel = useCallback(() => {
    const today = new Date()
    const patientListToday = patientList.filter((yakureki) => {
      const yakurekiDate = new Date(yakureki.created_at)
      return (
        yakurekiDate.getFullYear() === today.getFullYear() &&
        yakurekiDate.getMonth() === today.getMonth() &&
        yakurekiDate.getDate() === today.getDate()
      )
    })
    const yakurekiLength = patientListToday.length
    const label = '患者-' + String(yakurekiLength + 1)
    return label
  }, [patientList])

  useEffect(() => {
    setName(createLabel())
  }, [createLabel, setName])

  // 薬剤師が1人の場合は自動選択
  useEffect(() => {
    if (pharmacistList.length === 1 && !pharmacistId) {
      setPharmacistId(pharmacistList[0].id)
    }
  }, [pharmacistList, pharmacistId, setPharmacistId])

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80%',
        padding: '16px',
      }}
    >
      <Stack
        sx={{
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
        direction="column"
        spacing={2}
      >
        <TextField
          label={'患者氏名'}
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          sx={{ maxWidth: 400 }}
        />
        {recordButton}
        {pharmacistList.length === 0 ? (
          <Typography color="text.secondary" variant="body2">
            ポータルから薬剤師を登録してください
          </Typography>
        ) : pharmacistList.length >= 1 ? (
          <FormControl fullWidth sx={{ maxWidth: 400 }}>
            <InputLabel>担当薬剤師</InputLabel>
            <Select
              value={pharmacistId}
              label="担当薬剤師"
              onChange={(e) => setPharmacistId(e.target.value)}
            >
              {pharmacistList.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  {p.display_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : null}
        <TextField
          label={'メモ（任意）'}
          value={memo}
          onChange={(e) => setMemo(e.target.value)}
          placeholder="申し送りなどを自由記述"
          fullWidth
          multiline
          minRows={2}
          maxRows={4}
          sx={{ maxWidth: 400 }}
        />
      </Stack>
    </Box>
  )
}
